import i18next from 'i18next';
import backend from 'i18next-http-backend';
import ICU from 'i18next-icu';
import { initReactI18next } from 'react-i18next';

import fenrirI18n from '@packages/fenrir/locales/i18n';

import appBar from './locales/en/appBar.json';
import components from './locales/en/components.json';
import confirmation from './locales/en/confirmation.json';
import contact from './locales/en/contact.json';
import contactDetails from './locales/en/contactDetails.json';
import countries from './locales/en/countries.json';
import coverageScore from './locales/en/coverageScore.json';
import dashboardUi from './locales/en/dashboard-ui.json';
import dataExplorer from './locales/en/dataExplorer.json';
import datePicker from './locales/en/datePicker.json';
import detailsPage from './locales/en/detailsPage.json';
import downloads from './locales/en/downloads.json';
import error from './locales/en/error.json';
import eventLogDetails from './locales/en/eventLogDetails.json';
import fileAttachment from './locales/en/fileAttachment.json';
import filter from './locales/en/filter.json';
import formValidation from './locales/en/formValidation.json';
import icon from './locales/en/icon.json';
import layouts from './locales/en/layouts.json';
import map from './locales/en/map.json';
import navMenu from './locales/en/navMenu.json';
import organizationSwitch from './locales/en/organizationSwitch.json';
import pageNotFound from './locales/en/pageNotFound.json';
import pageToolbar from './locales/en/pageToolbar.json';
import reports from './locales/en/reports.json';
import table from './locales/en/table.json';
import ui from './locales/en/ui.json';
import widgetEmptyData from './locales/en/widget-empty-data.json';

// TODO: https://www.i18next.com/how-to/add-or-load-translations#lazy-load-in-memory-translations
// TODO: naming convention "unavailable-page" vs "organizationSwitch" for example
i18next
  .use(ICU)
  .use(backend)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false, // react already safe from xss
    },
    lng: 'en',
    resources: {
      en: {
        appBar, // TODO: Should go in `packages/components/src/app-bar`
        components, // TODO: Should be reviewed and splitted
        confirmation,
        contactDetails,
        contact,
        countries,
        coverageScore,
        'dashboard-ui': dashboardUi,
        dataExplorer,
        datePicker,
        detailsPage,
        downloads,
        eventLogDetails,
        error,
        fileAttachment,
        filter,
        formValidation,
        icon,
        layouts,
        map,
        navMenu,
        organizationSwitch,
        pageNotFound,
        pageToolbar, // TODO: Should go in `packages/components/`
        reports,
        table,
        ui,
        'widget-empty-data': widgetEmptyData,
      },
    },
    returnNull: false,
  });

i18next.on('languageChanged', (lng) => {
  fenrirI18n.changeLanguage(lng);
});

export default i18next;
